import { request } from "@esri/arcgis-rest-request";

export const Certify = async (payLoad, Config) =>  {
    
  console.log("Payload:", JSON.stringify(payLoad));

  try {  
        //const resp = await request(`${Config.server.serverUrl}/S4L_CS_Boundaries/FeatureServer/1/updateFeatures`,{
        const resp = await request(`${Config.server.portalUrl}/sharing/servers/${Config.server.layerPortalItem}/rest/services/S4L/S4L_CS_Boundaries/FeatureServer/1/updateFeatures`,{
            httpMethod: 'POST',
            params: {
            token: Config.server.apiKey,
            features: payLoad,
            f: "json"
           }});
        console.log(resp);
        return resp;
    } catch (error) {
        console.log(error);
        return null;
    } 
}


